import React, { FC, PropsWithChildren } from 'react';

type GlassdoorProps = {
  /** The color of the icon. */
  color?: string;
};

const Glassdoor: FC<PropsWithChildren<GlassdoorProps>> = ({ color = 'currentcolor' }) => (
  <svg className="social-icon social-icon-gd" viewBox="0 0 10.89001 18" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.89 2.8416V1.677L2.0224.0293A1.71 1.71 0 0 0 0 1.7105v14.8478a1.4403 1.4403 0 0 0 1.9946 1.3292l7.7883-3.248a1.8 1.8 0 0 0 1.107-1.6613V3.5166L9.09 3.4v8.588a1.395 1.395 0 0 1-.9102 1.308L3.24 15.1266V3.2443a1.125 1.125 0 0 1 1.25-1.118z"
      fill={color}
    />
  </svg>
);

export default Glassdoor;
